import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

interface DetailsRelated extends Vue {
    isShow: boolean;
}

interface RelatedOverview extends Vue {
    results: any[];
}

const DetailsRelated = {
    computed: {
        isShow: {
            get(this: DetailsRelated) {
                const n = this.$route.name;
                // [TODO] return n === "purchasedetail" || n === "rentdetail";
                return n === "realestatedetail";
            },
        },
    },
} as ComponentOptions<DetailsRelated>;

const RelatedOverview = {
    template: "#realestateOverview",
    computed: {
        results: {
            get(this: DetailsRelated) { return this.$store.state.details.nearObjects || []; },
        },
    },
} as ComponentOptions<RelatedOverview>;


export { DetailsRelated, RelatedOverview };



// WEBPACK FOOTER //
// ./src/components/related.ts